import styled from 'styled-components';

export const PanelTitle = styled.span`
  font-size: 125%;
  font-weight: bold;
`;
